/**
 * ReportsHarvestInspectionSpoiltDefectPercentage
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectReportsHarvestInspectionValue } from '../../services/reportsHarvestInspections/selectors';

interface Props {
    spoiltDefectPercentage?: ?number;
}

export class ReportsHarvestInspectionSpoiltDefectPercentage extends React.PureComponent<Props> {
    render() {
        const { spoiltDefectPercentage } = this.props;
        if (!spoiltDefectPercentage && spoiltDefectPercentage !== 0) {
            return null;
        }
        return `${spoiltDefectPercentage}%`;
    }
}

const mapStateToProps = createStructuredSelector({
    spoiltDefectPercentage: makeSelectReportsHarvestInspectionValue(
        'spoiltDefectPercentage'
    )
});

export default connect(mapStateToProps)(
    ReportsHarvestInspectionSpoiltDefectPercentage
);
